import React from 'react'

import AbsolutePageTemplate from '../../../../components/templates/AbsolutePageTemplate'
import PageContent from '../_shared/PageContent'
import PageHeader from '../_shared/PageHeader'
import ServiceOrderLoader from '../_load/ServiceOrderLoader'

const TemplateRelatorioPdfPage = ({ id, templateId }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrderLoader id={id}>
        <PageHeader templateId={parseInt(templateId)} />
        <PageContent />
      </ServiceOrderLoader>
    </AbsolutePageTemplate>
  )
}

export default TemplateRelatorioPdfPage
